import { SearchStoplight } from "./SearchStoplight";

export default SearchStoplight;

export { SearchStoplight };
